const state = {
  nowNotBrowsedRedPacketNum: 0, // 获取当前用户未浏览的红包数量
  messageNotificationRedPoint: false // 消息通知小红点
}

const mutations = {
  SET_REDPACKET_PARAMS: (state, payload) => {
    state.nowNotBrowsedRedPacketNum = payload
  },
  SET_MESSAGE_NOTIFICATION_RED_POINT: (state, payload) => {
    console.log(payload, 'VUEX-===消息通知小红点')
    state.messageNotificationRedPoint = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
